export class PrimeTableColumn {
  public display?: boolean = true;
  public exportable?: boolean = true;
  public field: string;
  public header?: string = '';
  public headerPosition?: 'left' | 'right';
  public sort?: boolean = true;
  public toolTip?: string;
}
